export enum FinancialTransactionGroupTypeEnum {
    INSTALLMENT = 'INSTALLMENT',
    RECURRENT = 'RECURRENT'
}

export enum FinancialTransactionGroupTypeLabelEnum {
    INSTALLMENT = 'Parcelado',
    RECURRENT = 'Recorrente'
}
